import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { applyBrandTitle } from "@/lib/brand";

function BrandTitle() {
  const { pathname } = useLocation();
  useEffect(() => { applyBrandTitle(); }, [pathname]);
  return null;
}
import { Toaster } from "@/components/ui/sonner";
import { OperatorProvider } from "@/context/OperatorContext";
import { CustomerProvider } from "@/context/CustomerContext";
import Landing from "@/pages/Landing";
import OperatorLogin from "@/pages/OperatorLogin";
import AfterAccess from "@/pages/AfterAccess";
import SsoLaunch from "@/pages/SsoLaunch";
import AdminDashboard from "@/pages/AdminDashboard";
import TenantDashboard from "@/pages/TenantDashboard";
import CustomerPortal from "@/pages/CustomerPortal";
import DemoShop from "@/pages/DemoShop";
import PreviewHost from "@/pages/PreviewHost";
import AppointmentBooking from "@/pages/AppointmentBooking";
import ManageAppointment from "@/pages/ManageAppointment";
import JobRequest from "@/pages/JobRequest";
import QuoteView from "@/pages/QuoteView";
import ConnectPublic from "@/pages/ConnectPublic";
import BookPage from "@/pages/BookPage";
import WidgetHost from "@/pages/WidgetHost";
import PopupsPage from "@/pages/PopupsPage";
import { VerifyEmail, ResetPassword, MagicLogin } from "@/pages/AccountActions";
import JoinPage from "@/pages/JoinPage";
import ContractSign from "@/pages/ContractSign";
import SsoRedirect from "@/pages/SsoRedirect";

// App-switch / MorrAccess launch links may land on the site root with a one-time ?lt= pass.
function RootRoute() {
  const q = new URLSearchParams(window.location.search);
  const lt = q.get("lt");
  const brand = q.get("brand") ? `&brand=${encodeURIComponent(q.get("brand"))}` : "";
  return lt ? <Navigate to={`/sso/launch?lt=${encodeURIComponent(lt)}${brand}`} replace /> : <Landing />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <BrandTitle />
        <Routes>
          <Route path="/" element={<RootRoute />} />
          <Route path="/demo" element={<DemoShop />} />
          <Route path="/preview/:slug" element={<PreviewHost />} />
          <Route path="/s/:slug/appointments" element={<AppointmentBooking />} />
          <Route path="/appt/:token" element={<ManageAppointment />} />
          <Route path="/s/:slug/request" element={<JobRequest />} />
          <Route path="/q/:token" element={<QuoteView />} />
          <Route path="/c/:slug" element={<ConnectPublic />} />
          <Route path="/c/:slug/:pro" element={<ConnectPublic />} />
          <Route path="/s/:slug/book" element={<BookPage />} />
          <Route path="/s/:slug/popups" element={<PopupsPage />} />
          <Route path="/w/:slug/:widget" element={<WidgetHost />} />
          <Route path="/portal" element={<CustomerProvider><CustomerPortal /></CustomerProvider>} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/magic-login" element={<CustomerProvider><MagicLogin /></CustomerProvider>} />
          <Route path="/contract/:token" element={<ContractSign />} />
          <Route path="/connect" element={<OperatorProvider><OperatorLogin /></OperatorProvider>} />
          {["", "/connect"].flatMap((p) => [
            <Route key={`${p}join`} path={`${p}/join/:slug`} element={<JoinPage />} />,
            <Route key={`${p}login`} path={`${p}/login`} element={<OperatorProvider><OperatorLogin /></OperatorProvider>} />,
            <Route key={`${p}redirect`} path={`${p}/sso/redirect`} element={<SsoRedirect />} />,
            <Route key={`${p}after`} path={`${p}/after-access`} element={<OperatorProvider><AfterAccess /></OperatorProvider>} />,
            <Route key={`${p}launch`} path={`${p}/sso/launch`} element={<OperatorProvider><SsoLaunch /></OperatorProvider>} />,
            <Route key={`${p}admin`} path={`${p}/admin`} element={<OperatorProvider><AdminDashboard /></OperatorProvider>} />,
            <Route key={`${p}dash`} path={`${p}/dashboard`} element={<OperatorProvider><TenantDashboard /></OperatorProvider>} />,
          ])}
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
